export default function json2jsonl(json) {
    const arr = validateArray(json)

    let jsonl = '';
    arr.map(x => {
        jsonl += serializeJsonlLine(x) + '\n';
    })
   
    return jsonl;
}

/** Serialize exactly one firmware/design JSONL record, without its framing newline. */
export function serializeJsonlLine(value) {
    let line = JSON.stringify(value);
    // Convert icon/non-BMP Unicode characters to explicit UTF-16 notation.
    // A codepoint above U+FFFF is two UTF-16 code units and must be emitted as
    // a valid high/low surrogate pair for the firmware JSON parser.
    line = line.replace(/[\uE000-\uF8FF]|[\u{10000}-\u{10FFFF}]/gu, (char) => {
        const codepoint = char.codePointAt(0);
        if (codepoint <= 0xFFFF) {
            return `\\u${codepoint.toString(16).toUpperCase().padStart(4, '0')}`;
        }
        const value = codepoint - 0x10000;
        const high = 0xD800 + (value >> 10);
        const low = 0xDC00 + (value & 0x3FF);
        return `\\u${high.toString(16).toUpperCase()}\\u${low.toString(16).toUpperCase()}`;
    });
    // Normalize double-escaped \\uXXXX (literal backslash from stored notation) to \uXXXX
    return line.replace(/\\\\u([\dA-Fa-f]{4})/g, '\\u$1');
}

function validateArray(arr) {
    if (!Array.isArray(arr)) {
        throw Error('Could not find array.')
    }
    return arr
}
